var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"c-mobile-nav-close t-heading-6 j-mobile-nav__close",class:['l-flex','l-flex--align-center'],attrs:{"type":"button","tabindex":"2"},on:{"click":_vm.emitClick}},[_c('span',[_vm._v(" × ")]),_vm._v("\n  Close\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }